import React from 'react';

import { Toolbar, Box, Typography } from '@mui/material';
import { useAppSelector } from 'src/common/hooks/reduxHooks';

import { ReactComponent as LogoBlue } from '../../../common/assets/icons/logo_blue.svg';
import { ReactComponent as UserIconWhite } from '../../../common/assets/icons/user_icon_white.svg';
import { AppBar } from '../../../common/components/tfa-dashboard-layout/styles';

export const SmartLaunchHeader: React.FC = () => {
  const { user } = useAppSelector((state) => state.model);

  return (
    <AppBar position='fixed' open={false} className='header-appbar'>
      <Toolbar>
        <LogoBlue />
        <Box sx={{ flexGrow: 1 }} />
        <Box
          sx={{
            display: { xs: 'flex', md: 'flex', alignItems: 'center' },
          }}
        >
          <Typography
            sx={{ mr: '12px', display: { xs: 'none', md: 'block' } }}
            color='text.primary'
          >
            {user?.fullName}
          </Typography>
          <UserIconWhite />
        </Box>
      </Toolbar>
    </AppBar>
  );
};
